import { InvoiceEmailDeliveryState } from "../../../types/neWebApi.types";

export const EMAIL_IN_PROGRESS_STATES = new Set([
  InvoiceEmailDeliveryState.dispatched,
  InvoiceEmailDeliveryState.created,
  InvoiceEmailDeliveryState.sent
]);

export const EMAIL_ERROR_STATES = new Set([
  InvoiceEmailDeliveryState.hard_bounced,
  InvoiceEmailDeliveryState.soft_bounced,
  InvoiceEmailDeliveryState.spam_complaint,
  InvoiceEmailDeliveryState.failed,
  InvoiceEmailDeliveryState.suppressed,
  InvoiceEmailDeliveryState.policy_rejected
]);

export const EMAIL_ERROR_TOOLTIP_KEYS: Partial<
  Record<InvoiceEmailDeliveryState, string>
> = {
  [InvoiceEmailDeliveryState.hard_bounced]:
    "errors.PPA.EmailDelivery.hard_bounced",
  [InvoiceEmailDeliveryState.soft_bounced]:
    "errors.PPA.EmailDelivery.soft_bounced",
  [InvoiceEmailDeliveryState.spam_complaint]:
    "errors.PPA.EmailDelivery.spam_complaint",
  [InvoiceEmailDeliveryState.failed]: "errors.PPA.EmailDelivery.failed",
  [InvoiceEmailDeliveryState.suppressed]: "errors.PPA.EmailDelivery.suppressed",
  [InvoiceEmailDeliveryState.policy_rejected]:
    "errors.PPA.EmailDelivery.policy_rejected"
};
